import React, {
  ChangeEvent,
  MutableRefObject,
  useEffect,
  useMemo,
  useState,
} from 'react';
import cx from 'classnames';

interface SliderbarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inverse?: boolean;
}

const Sliderbar = React.forwardRef<HTMLInputElement, SliderbarProps>(
  (
    { className, min, max, value, inverse, ...props },
    ref: MutableRefObject<HTMLInputElement>
  ) => {
    const [controlledValue, setControlledValue] = useState(value);

    useEffect(() => {
      setControlledValue(value);
    }, [value]);

    const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
      const val = parseInt(e.currentTarget.value);
      setControlledValue(val);
      props.onChange && props.onChange(e);
      e.preventDefault();
    };

    const percent = useMemo(
      () =>
        ((Number(controlledValue) - Number(min)) * 100) /
        (Number(max) - Number(min)),
      [controlledValue]
    );

    return (
      <div
        className={cx('slider-bar', className && className, {
          inverse: inverse,
        })}
      >
        <input
          type="range"
          value={controlledValue}
          {...props}
          ref={ref}
          onChange={handleInput}
          min={min}
          max={max}
          style={{
            backgroundSize: (inverse ? 100 - percent : percent) + '% 100%',
          }}
        />
      </div>
    );
  }
);

Sliderbar.displayName = 'Sliderbar';
Sliderbar.defaultProps = {
  min: 0,
  max: 100,
  value: 0,
};

export default Sliderbar;
